import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { QuestionType } from 'src/app/models/questionType.model';
import { OptionsList } from 'src/app/models/optionsList.model';
import { Question } from 'src/app/models/question.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MenuQuestionComponent } from '../menu-question/menu-question.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
@Component({
    selector: 'que-range-question',
    imports: [CommonModule, ReactiveFormsModule, FormsModule, MatCheckboxModule, MenuQuestionComponent, TranslateDirective, TranslatePipe],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: RangeQuestionComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: RangeQuestionComponent,
            multi: true
        }
    ],
    templateUrl: './range-question.component.html',
    styleUrls: ['./range-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RangeQuestionComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() index?: number;
  @Output() focusEvent = new EventEmitter<boolean>();
  #builder = inject(FormBuilder);

  questionForm = this.#builder.group({
    id: [-1],
    type: new FormControl<QuestionType>({ id: -1, name: 'sds', category: -1, image: "" }),
    title: new FormControl<string>('', [Validators.required]),
    text: new FormControl<string>(''),
    optionsList: new FormControl<OptionsList | null>(null),

    fromNum: new FormControl<number | null>(1),
    toNum: new FormControl<number | null>(10),
    requierd: new FormControl<boolean>(false),
    collectionQuestionId: new FormControl<number | null>(null),
    stepId: [-1],
  });

  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;
  orginalQuestion?:Question;
  numberRange: number[] = Array.from({ length: 10 }, (_, i) => i + 1);

  ngOnInit(): void {
    this.questionForm.valueChanges.subscribe(question => {
      this.registerOnChangeCallback({...this.orginalQuestion, ...question });
    });
  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.questionForm.valid) {
      return null;
    }
    return { 'optionsValue': "not-valid" }
  }
  // writeValue(obj: String[]): void {
  //   this.optionsValue.patchValue({ op1:obj[0],op2:obj[1] }, { emitEvent: false });
  //   //this.onValidationChangeCallBack();xxx
  // }
  writeValue(obj: Question): void {
    this.orginalQuestion=obj;
    this.questionForm.patchValue({ ...obj }, { emitEvent: false });
    //this.onValidationChangeCallBack();xxx
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
}
